import {
  Allocation,
  Identifiable,
  Task,
  allocateResourceError,
} from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { isAllocationValid } from "../../entities/allocationValidator";
import { Interactor } from "./types";

function areAllocationsValid(allocations: Allocation[]): boolean {
  return allocations.every(isAllocationValid);
}

function hasAllocations(allocations: Allocation[]): boolean {
  return allocations.length > 0;
}

function saveAllocations(
  repository: Repository,
  allocations: Allocation[],
  task: Identifiable<Task>,
): Promise<Identifiable<Allocation>[]> {
  return repository.saveAllocations(task, allocations);
}

function createInteractor(repository: Repository): Interactor {
  return ({ task, allocations, project }) => {
    return present(
      areAllocationsValid(allocations) && hasAllocations(allocations)
        ? saveAllocations(repository, allocations, task)
            .then((savedAllocations) => ({
              task,
              allocations: savedAllocations,
              project,
            }))
            .catch((e) =>
              Promise.reject({
                error: { ...allocateResourceError, ...e },
                task,
                allocations,
              }),
            )
        : Promise.reject({
            allocations,
            task,
          }),
    );
  };
}

export type { Interactor };

export { createInteractor };
